import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    lineHeight: 1.2,
    textAlign: 'center',
    fontSize: 18,
  },
  textDescription: {
    lineHeight: 1.3,
    fontSize: 15,
  },
}));
